var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLessonIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke: #1d7777;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2.1px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "st0",
    d: "M14.1,2.6H5.7c-.6,0-1.1.2-1.5.6s-.6.9-.6,1.5v16.7c0,.6.2,1.1.6,1.5.4.4.9.6,1.5.6h12.5c.6,0,1.1-.2,1.5-.6s.6-.9.6-1.5v-12.5l-6.2-6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    className: "st0",
    d: "M14.1,2.6v6.2h6.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    className: "st0",
    d: "M16.2,14H7.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    className: "st0",
    d: "M16.2,18.2H7.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    className: "st0",
    d: "M9.9,9.9h-2.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonIc);
export default __webpack_public_path__ + "static/media/lesson_ic.1f76b40b1b2fefd7bc7c73acb7e451fc.svg";
export { ForwardRef as ReactComponent };